
import { Component, Vue } from 'vue-property-decorator'
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateRepeatableEventForm } from '@/services/Calendar/RepeatableEvents/forms/CreateRepeatableEventForm';
import {
  ApiCreateRepeatableEventsInterface,
} from "@/services/Calendar/RepeatableEvents/Interfaces";
import RepeatableEventsRepository from '@/services/Calendar/RepeatableEvents';

@Component({
  inject: [
    'repeatableEventsRepository',
  ],
})
export default class CreateRepeatableEvent extends Vue {
  private readonly repeatableEventsRepository!: RepeatableEventsRepository;

  private loading: boolean = true;
  private dateMenu: boolean = false;
  private attendanceLimit: boolean = false;

  private form: WPXFormValue<CreateRepeatableEventForm> = new WPXFormValue(CreateRepeatableEventForm);
  private repeatEvery: Array<{ value: number, text: string }> = [{
    value: 0,
    text: 'Weekly',
  }, {
    value: 1,
    text: 'Once every other week',
  }, {
    value: 2,
    text: 'Weekly Custom',
  }, {
    value: 3,
    text: 'Monthly',
  }, {
    value: 4,
    text: 'Yearly',
  }];
  private weeklyCustom: Array<{ value: number, text: string }> = [{
    value: 0,
    text: 'Sunday',
  }, {
    value: 1,
    text: 'Monday',
  }, {
    value: 2,
    text: 'Tuesday',
  }, {
    value: 3,
    text: 'Wednesday',
  }, {
    value: 4,
    text: 'Thursday',
  }, {
    value: 5,
    text: 'Friday',
  }, {
    value: 6,
    text: 'Saturday',
  }];

  private async created(): Promise<void> {
    this.form.data.author = this.$store.getters.id;
    this.loading = false;
  }

  private async createRecurringEvent(): Promise<void> {
    try {
      const repeatableEvent = {
        name: this.form.data.name,
        description: this.form.data.description,
        location: this.form.data.location,
        author: this.form.data.author,
        withAttendance: this.form.data.withAttendance,
        attendanceLimit: this.attendanceLimit ? Number(this.form.data.attendanceLimit) : undefined,
        date: this.form.data.date ? new Date(this.form.data.date) : new Date(),
        repeatEvery: this.form.data.repeatEvery,
      } as unknown as ApiCreateRepeatableEventsInterface;

      if (this.form.data.signUpEndDate > 0) {
        repeatableEvent.signUpEndDate = Number(this.form.data.signUpEndDate);
      }

      if (this.form.data.repeatEvery === 2) {
        repeatableEvent.weeklyCustom = this.form.data.weeklyCustom;
      }

      await this.repeatableEventsRepository.createRepeatableEvent(repeatableEvent);

      this.$successDialog.show(`Repeatable event '${this.form.data.name}' has been created.`);

      this.formReset();
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }

  private formReset(): void {
    this.form.data.name = '';
    this.form.data.description = '';
    this.form.data.location = '';
    this.form.data.author = '';
    this.form.data.withAttendance = false;
    this.form.data.attendanceLimit = 0;
    this.form.data.date = '';
    this.form.data.signUpEndDate = 0;
    this.form.data.repeatEvery = 0;
    this.form.data.weeklyCustom = [];
  }
}
